import {WixSdk} from '@wix/js-sdk-wrapper';
import {Player} from '@wix/music-player';
import {Observable} from 'rxjs';
import {filter, tap, withLatestFrom} from 'rxjs/operators';
import {pubSub} from './pubSub';

export function subscribeToModal(player$: Observable<Player>) {
  const compId = WixSdk.Utils.getCompId();
  return pubSub<{openerCompId: string}>('modal.opened', false).pipe(
    filter((event) => event.openerCompId === compId),
    withLatestFrom(player$),
    tap(([_, player]) => {
      WixSdk.PubSub.publish('widget.model-data', player.getModelData());
    }),
  );
}
